<template>
  <el-dialog
    :title="查看"
    :close-on-click-modal="false"
    width="80%"
    :visible.sync="visible">
    <el-form :inline="true" size="mini" :model="dataForm" ref="dataForm"  label-width="120px">
       <el-row>
           <el-form-item label="采购组织" prop="purOrg">
               <el-input clearable size="mini" v-model="dataForm.purOrg" :disabled = "true"></el-input>
           </el-form-item>
           <el-form-item label="评价年度" prop="evaYear">
               <el-input clearable size="mini" v-model="dataForm.evaYear" :disabled = "true"></el-input>
           </el-form-item>
           <el-form-item label="年度分类" prop="evaType">
              <el-input clearable size="mini" v-model="dataForm.evaType" :disabled = "true"></el-input>
           </el-form-item>
       </el-row>
    </el-form>
    <div v-loading="dataListLoading">
        <el-table :data="dataList" size="mini" :row-class-name="rowClassName"
                  :height="style.gridStyle.height" @selection-change="selectionChangeHandle"
                  :header-cell-style="{background:'#f5f5f5'}" border>
            <el-table-column header-align="center" label="序号" align="center" width="50">
                <template slot-scope="scope">
                    {{ scope.row.rowid }}
                </template>
            </el-table-column>
            <el-table-column prop="purOrg" header-align="center" align="center" label="采购组织代码" min-width="80">
                <template slot-scope="scope">
                    {{ scope.row.purOrg }}
                </template>
            </el-table-column>
            <el-table-column prop="desc" header-align="center" align="left" label="绩效评价名称" min-width="180">
                <template slot-scope="scope">
                     {{ scope.row.evaName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderCode" header-align="center" align="center" label="供应商代码" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.venderCode }}
                </template>
            </el-table-column>
            <el-table-column prop="venderName" header-align="center" align="center" label="供应商名称" min-width="120">
                <template slot-scope="scope">
                    {{ scope.row.venderName }}
                </template>
            </el-table-column>
            <el-table-column prop="venderAbbreviation" header-align="center" align="center" label="供应商简称" min-width="90">
                <template slot-scope="scope">
                    {{ scope.row.venderAbbreviation }}
                </template>
            </el-table-column>
            <el-table-column prop="total" header-align="center" align="center" label="供应商得分" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.total }}
                </template>
            </el-table-column>
            <el-table-column prop="no" header-align="center" align="center" label="排名" min-width="50" >
                <template slot-scope="scope">
                    {{ scope.row.no }}
                </template>
            </el-table-column>
            <el-table-column prop="classType" header-align="center" align="center" label="供应商分类" min-width="60" >
                <template slot-scope="scope">
                    {{ scope.row.classType }}
                </template>
            </el-table-column>
            <el-table-column  align="center"label="质量">
                <el-table-column prop="sckkx" align="center" :label="'市场可靠性质量\n(6分)'" width="70">
                </el-table-column>
                <el-table-column prop="rclbj" :label="'入厂零部件质量\n(10分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="scgc" :label="'生产过程质量\n(18分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="lbjzl" :label="'零部件质量改进\n(6分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="成本">
                <el-table-column prop="jcbyj" align="center" :label="'降成本业绩\n(10分)'" width="70">
                </el-table-column>
                <el-table-column prop="pjjgsp" :label="'平均价格水平\n(5分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="swphd" :label="'商务配合度\n(5分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="交付">
                <el-table-column prop="lbjgh" align="center" :label="'零部件供货\n(10分)'" width="70">
                </el-table-column>
                <el-table-column prop="ghfw" :label="'供货服务\n(10分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="服务">
                <el-table-column prop="xcfwzc" align="center" :label="'现场服务支持\n(3分)'" width="70">
                </el-table-column>
                <el-table-column prop="shpjjf" :label="'售后配件交付\n(4分)'" align="center" width="70">
                </el-table-column>
                <el-table-column prop="shfwxysd" :label="'售后服务响应速度\n(3分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
            <el-table-column  align="center"label="开发">
                <el-table-column prop="xcpkfph" align="center" :label="'新产品开发配合\n(5分)'" width="70">
                </el-table-column>
                <el-table-column prop="xpkfyj" :label="'新品开发业绩\n(5分)'" align="center" width="70">
                </el-table-column>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">确定</el-button>
      <!--<el-button type="primary" @click="dataFormSubmit()">确定</el-button>-->
    </span>
  </el-dialog>
</template>

<script>
import {
    getSupplierEvaList
} from '@/controller/supplier'
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
            key: '',
            purOrg: '',
            evaYear: '',
            evaType: '',
            evaTypeValue: '',
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        style: {
            leftStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 325) + "px",
                overflow: "auto"
            },
            rightStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 205) + "px"
            },
            gridStyle: {
                height: (parseInt(document.documentElement['clientHeight']) - 215) + "px"
            }
        },
      }
    },
    methods: {
        init (row) {
            debugger
            this.dataForm.purOrg = row.purOrg
            this.dataForm.evaTypeValue = row.evaType
            this.dataForm.evaYear = row.evaYear
            if(row.evaType == 0) {
                this.dataForm.evaType = "年度"
            } else if(row.evaType == 1) {
                this.dataForm.evaType = "上半年度"
            } else if(row.evaType == 2) {
                this.dataForm.evaType = "下半年度"
            }
            this.visible = true
            this.getDataList()
       },
       // 获取数据列表
       getDataList() {
          this.dataListLoading = true
          getSupplierEvaList({
              'pageNo': this.pageIndex,
              'pageSize': this.pageSize,
              'purOrg': this.dataForm.purOrg,
              'evaType': this.dataForm.evaTypeValue,
              'evaYear': this.dataForm.evaYear
          }).then(data => {
              if (data && data.code === '00') {
                  this.dataList = data.body.records
                  this.totalPage = data.body.total
              } else {
                  this.dataList = []
                  this.totalPage = 0
              }
          }).catch((e) => {
              console.log(e)
          }).finally(() => {
              this.dataListLoading = false
          })
      },
      // 每页数
      sizeChangeHandle(val) {
          this.pageSize = val
          this.pageIndex = 1
          this.getDataList()
      },
      // 当前页
      currentChangeHandle(val) {
          this.pageIndex = val
          this.getDataList()
      },
      //多选
      selectionChangeHandle(val) {
          console.log(val)
          this.dataListSelections = val
      },
      rowClassName({
                       row,
                       rowIndex
                   }) {
          //把每一行的索引放进row.id
          row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
      },
    }
  }
</script>
